import { BenchmarkColorRepo } from '../../repositories';

export const makeBenchmarkColor = () => {
  return new BenchmarkColorRepo();
}
